import React from 'react';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="about-hero-overlay"></div>
        <div className="about-hero-content">
          <h1>About Us</h1>
          <p>Your trusted travel partner in Kerala and beyond</p>
        </div>
      </div>

      <section className="about-story-section">
        <div className="container">
          <div className="about-story">
            <div className="about-story-content">
              <h2>Our Story</h2>
              <p>
                Holistic Holidays LLP is founded by a group of passionate travel enthusiasts with a vision to showcase the authentic beauty of Kerala to travelers worldwide. As a partnership company registered with the Government of Kerala, what began as a small venture has since evolved into a trusted travel agency known for creating personalized travel experiences.
              </p>
              <p>
                Our team is made up of experienced locals who possess deep knowledge of Kerala's culture, traditions, and hidden gems. While Kerala remains our heart and soul, we're excited to extend our expertise to curate memorable experiences across India, helping both domestic and international travelers discover the diverse wonders of our incredible country.
              </p>
            </div>
            <div className="about-story-image">
              <img src="/images/kadhakali.jpg" alt="Kerala Experience" />
            </div>
          </div>
        </div>
      </section>

      <section className="mission-vision-section">
        <div className="container">
          <div className="mission-vision-grid">
            <div className="mission-vision-card">
              <h3>Our Mission</h3>
              <p>
                To create an authentic, sustainable, and memorable travel experiences that showcase the true essence of Kerala 
                and India while promoting responsible tourism practices for both domestic and international travelers.
              </p>
            </div>
            <div className="mission-vision-card">
              <h3>Our Vision</h3>
              <p>
                To be the most trusted travel partner for travelers seeking authentic experiences in Kerala and beyond, 
                known for our personalized approach and commitment to sustainable tourism.
              </p>
            </div>
            <div className="mission-vision-card">
              <h3>Our Values</h3>
              <p>
                Authenticity, Sustainability, Personalization, Excellence, and Respect for local cultures and environments 
                guide everything we do at Holistic Holidays LLP.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="philosophy-section">
        <div className="container">
          <div className="philosophy-content">
            <div className="philosophy-text">
              <h2>Our Philosophy</h2>
              <p>
                We believe that travel should be a transformative experience, nourishing your body, mind, and spirit. 
                While Kerala remains our primary focus, we're expanding our horizons to bring you the finest experiences 
                across India, blending rich heritage, stunning natural beauty, and holistic wellness traditions.
              </p>
              <h3>Our Expertise</h3>
              <p>
                As a Kerala-based travel company with deep roots in the state, we possess an intimate knowledge of its hidden gems and local secrets. 
                Our expanding network across India allows us to offer authentic experiences beyond Kerala while maintaining the same high standards 
                of personalized service and attention to detail that our clients have come to expect.
              </p>
            </div>
            <div className="philosophy-image">
              <img src="https://images.unsplash.com/photo-1593693411515-c20261bcad6e" alt="Kerala Backwaters" />
            </div>
          </div>
        </div>
      </section>

      <section className="offerings-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Offerings</h2>
            <p>Comprehensive travel services tailored to your needs</p>
          </div>
          <div className="offerings-list-container">
            <ul className="offerings-list">
              <li>Customized Kerala tour packages for individuals, families, and groups</li>
              <li>Pan-India travel experiences and multi-destination tours</li>
              <li>Wellness retreats and yoga holidays in Kerala and select destinations</li>
              <li>Cultural immersion experiences and village tours</li>
              <li>Adventure activities, such as trekking, kayaking, and cycling</li>
              <li>Luxury getaways and romantic escapes</li>
            </ul>
            <div className="join-us-message">
              <h3>Join Us on a Journey of Discovery</h3>
              <p>
                At Holistic Holidays LLP, we invite you to embark on a holistic journey through Kerala and beyond, where the boundaries 
                between traveler and local blur, and the beauty of our incredible destinations leaves an indelible mark on your heart.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="why-choose-section">
        <div className="container">
          <div className="section-header">
            <h2>Why Choose Holistic Holidays LLP?</h2>
            <p>What sets us apart as your travel partner</p>
          </div>
          <div className="why-choose-grid">
            <div className="why-choose-card">
              <h3>Local Expertise</h3>
              <p>Our team consists of locals with in-depth knowledge about Kerala's culture, traditions, and hidden gems, complemented by our growing network across India.</p>
            </div>
            <div className="why-choose-card">
              <h3>Personalized Approach</h3>
              <p>We craft each itinerary based on your preferences, ensuring a unique and tailored travel experience whether you're exploring Kerala or other Indian destinations.</p>
            </div>
            <div className="why-choose-card">
              <h3>Authentic Experiences</h3>
              <p>We focus on providing genuine experiences that showcase the true essence of our destinations beyond typical tourist attractions.</p>
            </div>
            <div className="why-choose-card">
              <h3>Responsible Tourism</h3>
              <p>We are committed to sustainable practices that benefit local communities and preserve the natural beauty of our destinations.</p>
            </div>
            <div className="why-choose-card">
              <h3>24/7 Support</h3>
              <p>Our team is available round-the-clock to assist you throughout your journey in Kerala and beyond.</p>
            </div>
            <div className="why-choose-card">
              <h3>Value for Money</h3>
              <p>We provide high-quality experiences at competitive prices, ensuring you get the best value for your investment.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage; 